import { Link } from 'react-router-dom';
import { AdSlot } from '../AdSlot';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = [
        { label: 'O nas', href: '/about' },
        { label: 'Regulamin', href: '/terms' },
        { label: 'Polityka prywatności', href: '/privacy' },
        { label: 'Kontakt', href: '/contact' },
        { label: 'Blog', href: '/blog' },
        { label: 'Pomoc', href: '/help' },
        { label: 'Reklama', href: '/advertising' },
    ];

    return (
        <footer className="bg-muted border-t border-border mt-8">
            <div className="max-w-[1400px] mx-auto px-4 py-6">
                <AdSlot name="footer" format="auto" className="mb-4" />
                {/* Links */}
                <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4">
                    {footerLinks.map((link) => (
                        <Link
                            key={link.label}
                            to={link.href}
                            className="text-sm text-muted-foreground hover:text-primary transition-colors"
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                {/* Separator */}
                <div className="nk-separator my-4" />

                {/* Bottom section */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm text-muted-foreground">
                    <span>© {currentYear}</span>
                    <span className="font-display text-base">
                        <span className="text-emerald-800 dark:text-emerald-400">Klaso</span>
                        <span className="text-amber-700 dark:text-amber-400">wisko</span>
                        <span className="text-foreground">.pl</span>
                    </span>
                    <span className="hidden sm:inline">–</span>
                    <span className="flex items-center gap-1">
                        Wykonane przez{' '}
                        <a 
                            href="https://www.zens.pl/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-primary hover:underline font-medium"
                        >
                            IT Zens
                        </a>
                    </span>
                </div>

                {/* Nostalgic tagline */}
                <p className="text-center text-xs text-muted-foreground mt-3">
                    Pamiętasz te czasy? Odnajdź swoją klasę!
                </p>
            </div>
        </footer>
    );
};
